export default "<style lang=\"sass\">\n  $color-pack: false;\n\n  @import '~vuetify/src/styles/main.sass';\n</style>\n";